import ReactOnRails from 'react-on-rails/client';
import CompetitionsOverview from '../../app/CompetitionsOverview.js';

ReactOnRails.register({CompetitionsOverview});